import { Button } from "@/components/ui/button";
import { useCreateProject } from "@/lib/hooks/useProjects";
import { FolderOpen, Plus } from "lucide-react";

export function EmptyProjectsState() {
  const createProject = useCreateProject();

  const handleCreateProject = () => {
    createProject.mutate({});
  };

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-6">
        <FolderOpen className="w-8 h-8 text-muted-foreground" />
      </div>

      <h3 className="text-lg font-medium text-foreground mb-2">
        No projects yet
      </h3>

      <p className="text-sm text-muted-foreground text-center max-w-md mb-6">
        Create your first project to start building with Fiberplane. You can
        generate code through our AI assistant or sync projects from your local
        machine.
      </p>

      <Button
        onClick={handleCreateProject}
        disabled={createProject.isPending}
        className="gap-2"
      >
        <Plus className="w-4 h-4" />
        Create Your First Project
      </Button>
    </div>
  );
}
